
import { Component, Vue } from "vue-property-decorator";
import NavBar from "@/components/navBar.vue";
import Feature from "./HomePage/feature.vue";
import Content from "./HomePage/content.vue";
import { appHomePage } from "@/req/homeIndex";
@Component({
  components: {
    NavBar,
    Feature,
    Content,
  },
})
export default class Index extends Vue {
  public isLoading = false;
  public data = {};
  /* public onRefresh() {
    this.detail();
  } */
  public async detail() {
    const res = await appHomePage();
    if (res.code === 200) {
      this.data = res.data;
      this.isLoading = false;
    }
  }
  public created() {
    this.detail();
  }
  public mounted() {
    (document as any)
      .querySelector("body")
      .setAttribute("style", "background-color:#f5f5f5");
  }
  public beforeCreate() {
    (document as any)
      .querySelector("body")
      .setAttribute("style", "background-color:#f5f5f5");
  }
  public destroyed() {
    document.body.removeAttribute("style");
  }
}
